import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Reveal from '../ui/Reveal';
import { ArrowRight, MapPin, Mail, Shield, Palette } from '../ui/Icons';

/** Full-bleed dealer finder: photograph behind, search box in a card in front. */
const DealerBand = () => {
  const [place, setPlace] = useState('');
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden">
      <img src="/images/web/fan-deck.jpg" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 w-full h-full object-cover -scale-x-100" />
      <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/20 to-transparent" />
      <div className="relative container py-16 md:py-24">
        <Reveal className="max-w-xl">
          <div className="bg-white rounded-3xl shadow-lift border border-brand-line p-7 sm:p-10">
            <span className="w-12 h-12 rounded-2xl bg-brand-blue text-white flex items-center justify-center shadow-blue">
              <MapPin size={22} />
            </span>
            <span className="vp-eyebrow mt-6">Find a Vertex dealer</span>
            <h2 className="vp-heading mt-3 text-3xl sm:text-4xl">Genuine paint and exact tinting, near you</h2>
            <p className="mt-4 text-brand-muted leading-relaxed">Authorised dealers stock batch-fresh Vertex products and tint any shade on the spot through Colour Mode.</p>
            <form
              className="mt-7 flex flex-col sm:flex-row gap-3"
              onSubmit={(e) => {
                e.preventDefault();
                navigate('/store-locator', { state: { place } });
              }}
            >
              <label htmlFor="dealer-place" className="sr-only">
                City or pincode
              </label>
              <input id="dealer-place" value={place} onChange={(e) => setPlace(e.target.value)} placeholder="Enter city or pincode" className="vp-input flex-1" />
              <button type="submit" className="vp-btn vp-btn-primary flex-shrink-0">
                Find dealers
                <ArrowRight />
              </button>
            </form>
            <ul className="mt-7 pt-6 border-t border-brand-line grid sm:grid-cols-3 gap-4 text-sm">
              <li className="flex items-center gap-2 text-brand-ink">
                <Shield size={16} className="text-brand-blue" /> Genuine stock
              </li>
              <li className="flex items-center gap-2 text-brand-ink">
                <Palette size={16} className="text-brand-blue" /> Colour Mode tinting
              </li>
              <li>
                <a href="mailto:support@vertexpaint.com" className="flex items-center gap-2 text-brand-ink hover:text-brand-blue">
                  <Mail size={16} className="text-brand-blue" /> Email support
                </a>
              </li>
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default DealerBand;
